<template>
  <div class="main-content sn-content">

  <!--  <el-card class="box-card clearfix">-->
    <el-row style="margin-bottom: 15px;background: #f4f4f5;padding: 15px 15px 0 0">
      <el-col :xs="12" :sm="14">
      <el-form class="search-form" ref="form" :model="searchForm">
        <el-form-item label="" label-width="20px">
          <el-input v-model="searchForm.name" placeholder="请输入名称" >
            <el-button slot="append" @click="getAgentConfigList" icon="el-icon-search"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      </el-col>
      <el-col :xs="12" :sm="10" justify="end">
        <!-- <router-link v-if="parseInt(userQuotaForAppli.quota) > parseInt(appliCnt) " :to="{path:'/appli/add'}"
                    style="color: #435465;float: right">
           添加应用
         </router-link>-->
        <router-link :to="{path:'/price/index',query: {from: 'turn'} }" class="pvt-color"
                     style="float: right">
          价格详情
        </router-link>
        <el-button v-if="userBalance > 0" class="pvt-color" type="text" style="float: right;padding: 0;marginRight:20px;" @click="gotoAgentAdd()">
          创建代理转发配置
        </el-button>
      </el-col>
    </el-row>
    <div v-if="user.role == 30">
      <el-tag style="margin-bottom: 15px;margin-right: 10px">代理连接数：{{channelCntResult.proxyChannelCnt}}</el-tag>
      <el-tag style="margin-bottom: 15px;">用户连接数：{{channelCntResult.userChannelCnt}}</el-tag>
    </div>


      <el-table
        :data="agentConfigList"    default-expand-all>

        <template slot="empty">
          <el-button v-if="userBalance > 0" @click="gotoAgentAdd()"
                     type="text"
                     size="small"
                     style="font-size:14px;"
                     class="pvt-color">申请代理转发配置
          </el-button>
        </template>
        <el-table-column type="expand">
          <template slot-scope="props">
            <!--      <span>{{props.rows.pocOrderDetails}}</span>-->
            <el-table
              :data="props.row.pocTurnPortMappings"
              style="width: 100%"
              border
              height="250">
              <el-table-column
                prop="id"
                label="id">
              </el-table-column>
              <el-table-column
                prop="orderId"
                label="订单Id-Basic">
              </el-table-column>
              <el-table-column
                prop="orderId1"
                label="订单Id-按流量">
              </el-table-column>
             <!-- <el-table-column
                prop="mappingId"
                label="端口映射ID">
              </el-table-column>-->

              <el-table-column
                prop="lanAddress"
                label="内网地址">
              </el-table-column>

              <el-table-column
                prop="inetPort"
                label="公网地址" width="270">
                <template slot-scope="scope">
                  https://turn.pingxingyun.com:{{scope.row.inetPort}}
                </template>
              </el-table-column>

              <el-table-column
                prop="connCnt"
                label="并发">
              </el-table-column>

              <el-table-column
                prop="createDate"
                label="创建时间">

                <template slot-scope="scope">
                  {{scope.row.createDate | formatDate}}
                </template>
              </el-table-column>
              <el-table-column
                prop="note"
                label="备注">
              </el-table-column>
              <el-table-column
                label="操作" width="100">
                <template slot-scope="scope">
                  <router-link
                    class="router-link-btn pvt-color"
                    :to="{ path: '/agentPortMapping/update', query: { id: scope.row.id,redirect:'/agent/index'}}">
                    编辑
                  </router-link>

                  <el-button  type="text"
                              class="pvt-color" style="position: relative;z-index: 999;"
                              @click="handleDeletePortMapping(scope.row.id)">
                    删除
                  </el-button>

                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          prop="clientId"
          label="clientId" width="300px">
        </el-table-column>
        <el-table-column
          prop="clientKey"
          label="clientKey" width="300px">
        </el-table-column>

        <el-table-column
          prop="name"
          label="名称">
        </el-table-column>
        <el-table-column
          label="clientKey状态">
          <template slot-scope="scope">
            <span class="info" v-if="scope.row.status == 1"> 有效</span>
            <span class="danger" v-if="scope.row.status == 0"> 无效</span>
          </template>
        </el-table-column>
        <el-table-column
          label="代理客户端状态">
          <template slot-scope="scope">
            <span class="info" v-if="scope.row.proxyClientStatus == 1"> 上线</span>
            <span class="danger" v-if="scope.row.proxyClientStatus == 0"> 下线</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="user.role == 30"
          label="用户是否连接">
          <template slot-scope="scope">
            <span class="info" v-if="scope.row.hasUserChannel == 1"> 有</span>
            <span class="danger" v-if="scope.row.hasUserChannel == 0"> 无</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createDate"
          label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作" width="150px">
          <template slot-scope="scope">
            <router-link
              class="router-link-btn pvt-color"
              v-if="!scope.row.pocTurnPortMappings.length > 0"
              :to="{ path: '/agentPortMapping/add', query: { clientId: scope.row.clientId,redirect:'/agent/index', userId : searchForm.userId}}">
              添加端口
            </router-link>
            <router-link
              class="router-link-btn pvt-color"
              :to="{ path: '/agent/update', query: { clientId: scope.row.clientId,redirect:'/agent/index'}}">
              编辑
            </router-link>

              <el-button   v-if="!scope.row.pocTurnPortMappings.length > 0"  type="text"
                         class="pvt-color" style="position: relative;z-index: 999;"
                          @click="handleDelete(scope.row.clientId)">
                删除
              </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="space-between" style="align-items: center;">
        <template v-if="$store.state.voucherBalance && $store.state.voucherBalance != ''">
          <p v-if="userBalance <= 0" class="balance-tip">温馨提示：您的余额不足，为了不影响您的使用，请及时充值。
            <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
              【去充值】
            </router-link>
          </p>
          <div v-else></div>
        </template>
        <template v-else>
          <p v-if="userBalance <= 0" class="balance-tip">温馨提示：您的余额不足，为了不影响您的使用，请及时充值。
            <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
              【去充值】
            </router-link>
          </p>
          <div v-else></div>
        </template>
        <PageComponent ref="pageInfo"></PageComponent>
      </el-row>
<!--    </el-card>-->
  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'

  export default {
    components: {PageComponent},
    data() {
      return {
        agentConfigList: [],
        searchForm:{
          orderId:this.$route.query.orderId,
          name:'',
          userId : this.$route.query.userId
        },
        channelCntResult: {},
        userBalance: this.$store.state.userBalance
      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      getAgentConfigList: function () {
        var params = {};
        params.userId = this.$store.state.user.userId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        if(this.searchForm.orderId != ''){
          params.orderId = this.searchForm.orderId;
        }
        if(this.searchForm.name != ''){
          params.name = this.searchForm.name;
        }
        if(this.user.role == 30){
          params.userId = this.searchForm.userId;
        }
        this.getRequest('/pocTurnKey/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              console.log(resp.data.result.records)
              this.agentConfigList = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
              //TODO:查询poc_product表查询具体的配合信息
            } else {
              Message.error(resp.data.message);
            }
          }
        })


      },

      getChannelCnt: function () {
        this.getRequest('/pocTurnKey/getChannelCnt', {}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.channelCntResult = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          }
        })


      },
      gotoAgentAdd() {
        if(this.searchForm.userId){
          this.$router.push({path: '/agent/add', query: { userId: this.searchForm.userId}})
        }else {
          this.$router.push({path: '/agent/add'})
        }

      },
      handleDelete(clientId) {
        var _this = this;
        _this.$confirm("确认删除？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: 'warning'
        }).then(() => {
          _this.doDelete(clientId);
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: "取消"
          });
        });
      },
      doDelete(clientId) {
        this.postRequestJson("/pocTurnKey/delete", {"clientId": clientId}).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            this.getAgentConfigList()
            this.$message({type: data.status, message: data.message});
          }
        });
      },

      handleDeletePortMapping(id) {
        var _this = this;
        _this.$confirm("确认删除？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: 'warning'
        }).then(() => {
          _this.doDeletePortMapping(id);
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: "取消"
          });
        });
      },
      doDeletePortMapping(id) {
        this.postRequestJson("/pocTurnPortMappings/delete", {"id": id}).then(resp => {
          if (resp && resp.status == 200) {
            var data = resp.data;
            this.getAgentConfigList()
            this.$message({type: data.status, message: data.message});
          }
        });
      },
    },
    mounted: function () {
      this.getAgentConfigList();
      if(this.user.role == 30){
        this.getChannelCnt();
      }
      this.$refs.pageInfo.initPagenator(this.getAgentConfigList, null);
    },
    beforeDestroy() {

    }
  }
</script>
<style scoped>
  .balance-tip {
    color:#F56C6C;
  }
</style>
